export const getMilestoneApproversAndNotificationUserIds = (
  project,
  roles,
  projectLeaderRoles
) => {
  const rolesGroup = roles
    ?.flatMap((role) => role.assignedUsers?.map((user) => user.userId))
    ?.filter((userId) => !!userId);
  const projectLeaderRolesGroup = projectLeaderRoles?.map(
    (role) => project.projectLeaders[role.regionId]
  );
  return [...new Set([...rolesGroup, ...projectLeaderRolesGroup])];
};
